module.exports = __webpack_public_path__ + "img/main-01-02.51dd5a05.png";